import { DataBean } from "../DataBean";

export class ConciliationStateConstant extends DataBean {


    public async getBankingConciliationStateConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingConciliationStateConstants_Number", [id]);
    }

}